import type { FC } from "react";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Bullet } from "pro-features/styled components/StyledLabel/Bullet";
import { Subtitle } from "pro-features/components/BoxSubtitle/src/styled";
import { WithAnimationContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/WithAnimationContainer";
import styled from "styled-components";

export const PeriodOverPeriodItem: FC<{ text: string; color: string }> = ({ color, text }) => {
    return (
        <FlexRow
            gap={"4px"}
            alignItems={"center"}
        >
            <Bullet color={color} />
            <Subtitle>{text}</Subtitle>
        </FlexRow>
    );
};

const VERTICAL_MARGIN = 24;
export const PageContainer = styled(WithAnimationContainer)`
    display: flex;
    flex-direction: column;
    gap: ${VERTICAL_MARGIN}px;
    @media print {
        display: block;
        & > * {
            margin-bottom: ${VERTICAL_MARGIN}px;
        }
    }
`;
